import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OptionsComponent } from 'app/opzioni/opzioni';
import { isPrimitive } from 'util';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { filter, map, merge } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

import { HttpResponse } from '@angular/common/http';
import { FormControl, FormGroup } from '@angular/forms';
import { IUser, OAuth2Service } from '../angular-rest';
import { ResetComponent } from '../opzioni/reset/reset';

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  styleUrls: ['./login.css'],
  providers: []
})
export class LoginComponent implements OnInit {

  formGroup = new FormGroup({
    username: new FormControl(),
    password: new FormControl()
  });
  user: IUser = { codice_fiscale: null, password: null };
  problem: string | false;
  readonly reason$: Observable<string>;
  showResetPasswordFlag: boolean = false

  private readonly onError: (error) => void;

  constructor(
    private auther: OAuth2Service,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
  ) {
    const reasonSubject = new Subject();
    this.onError = (error) => {
      debugger
      if (isPrimitive(error)) {
        reasonSubject.next(error);
      } else if ('error' in error && error.error) {
        reasonSubject.next(error.error);
      } else {
        console.error(error);
      }
    }

    this.reason$ = reasonSubject.pipe(
      merge(
        route.queryParams.pipe(
          filter(params => 'reason' in params),
          map(params => params.reason!)
        )
      ),
      map(reason => {
        switch (+reason) {
          case 0:
            this.showResetPassword();
            return "Username o password errati";
          case 1:
            return "Sessione scaduta.";
          case 2:
            return "Abbonamento non attivo. Contattare il supporto.";
          case 3:
            this.openCambioPassword()
            return "Password scaduta. Cambiare password.";
          default:
            return null;
        }
      })
    );

  }

  ngOnInit() {
    const {
      u,  // utente medico per login remoto
      a,  // token di accesso per login remoto
      r   // token di rinfresco per login remoto
    } = this.route.snapshot.queryParams

    if (u && a && r) {
      this.login({
        username: decodeURIComponent(u),
        access_token: decodeURIComponent(a),
        refresh_token: decodeURIComponent(r)
      })
    } else {
      console.error("Missing params: ", u, a, r)
    }
  }

  async showResetPassword() {
    this.showResetPasswordFlag = true
  }

  async login(tokens?) {
    debugger
    
		localStorage.removeItem('auth-cookie-shortcut');
		localStorage.removeItem('auth');
		localStorage.removeItem('agenda-web');
    
    this.problem = false;
    const loginSub = this.auther.login(tokens || this.user, tokens ? 'check' : 'password')
      .subscribe({
        error: (e: HttpResponse<string>) => {
          this.onError(e);
          setTimeout(() => loginSub.unsubscribe());
        },
        complete: async () => {
          setTimeout(() => loginSub.unsubscribe());

          await this.obtainRemoteAgendaToken()
          this.router.navigateByUrl('agende');
        }
      });


  }

  async obtainRemoteAgendaToken() {
    try {
      /* const response = await fetch(`${Config.baseURL}/oauth`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ...this.user, ...{ grant_type: "password" } })
      }); */

      const response = this.auther.lastResponse
      if (response) {
        debugger
        const json = JSON.parse(response['body'])

        // AGENDA_WEB: salvo i token nel local storage per potermi collegare all'agenda web
        // questi verranno inviati come parametri GET
        // i cookie infatti sono legati allo stesso db

        let username
        if (this.formGroup
          && this.formGroup.controls
          && this.formGroup.controls.username
          && this.formGroup.controls.username.value) {
          username = this.formGroup.controls.username.value
        } else {
          username = json['username']
        }

        localStorage.removeItem('auth-cookie-shortcut')
        localStorage.removeItem('agenda-web')
        localStorage.setItem(
          'agenda-web',
          JSON.stringify(
            {
              access: json['access'],
              refresh: json['refresh'],
              codice_fiscale: username,
              codice_fiscale_medico: username,
              refresh_expires: json['refresh'],
            }
          )
        )
        
        localStorage.setItem(
          'auth-cookie-shortcut',
          JSON.stringify(
            {
              access: json['access'],
              refresh: json['refresh'],
              codice_fiscale: username,
              codice_fiscale_medico: username,
              refresh_expires: json['refresh'],
            }
          )
        )
      }
    } catch (err) {
      console.error("Error obtain remote token")
      console.error(err)
    }
  }

  openResetPassword() {
    const modalRef = this.modalService.open(ResetComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.isLogin = true;

    modalRef.result.then(
      () => { },
      () => { }
    );
  }

  openCambioPassword() {
    const modalRef = this.modalService.open(OptionsComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.isLogin = true;

    modalRef.result.then(
      () => { },
      () => { }
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/login/login.ts